'use client'

import {observer} from 'mobx-react'

import {cn} from '@/src/shared/utils/functions'

import * as UI from './mobile-burger.styled'

export const MobileBurger = observer(({dark, open, onClick}: {dark?: boolean; onClick: (open: boolean) => void; open: boolean}) => {
  return <UI.MobileButton className={cn({open})} dark={dark} open={open} onClick={onClick} />
})
